import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Grid,
	Typography,
	Button,
	Divider
} from '@material-ui/core';

import ResponsiveDialog from "./ResponsiveDialog";

const styles = makeStyles(theme => ({
	subtitle: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(3)
	},

	dlgTitle: {
		paddingBottom: 0
	},

	buttonSection: {
		paddingTop: theme.spacing(1)
	}
}));

function UpgradeFreemiumDialog(props) {
	let classes = styles(),
		{open, closeHandler} = props;

	let content = (
		<Grid
			container
			justify="center"
			direction="column"
			alignItems="stretch"
			>
			<Grid item>
				<Typography className={classes.subtitle}>
					Before proceeding, we want to ensure you're ready to upgrade. A sales representative will reach out to assist you. If an agreement isn't reached, your account will downgraded after a certain time period.
				</Typography>
			</Grid>
			<Divider />
			<Grid item className={classes.buttonSection}>
				<Grid
					container
					justify="space-between"
					alignItems="center">
					<Grid item className={classes.cancelBtn}>
						<Button
							color="primary"
							onClick={() => closeHandler(false)}>
							Cancel
						</Button>
					</Grid>
					<Grid item>
						<Button
							color="primary"
							variant="contained"
							onClick={() => closeHandler(true)}>
							I want to upgrade
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);

	return (
		<ResponsiveDialog
			open={open}
			maxWidth="xs"
			title="Are you sure you want to upgrade?"
			content={content}
			hasCancel={true}
			closeHandler={closeHandler}
			titleClassName={classes.dlgTitle} />
	);
}

UpgradeFreemiumDialog.propTypes = {
	open: PropTypes.bool,
	closeHandler: PropTypes.func.isRequired
};

export default UpgradeFreemiumDialog;